
import { useEffect, useState } from "react"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"
import url from "../api/url"
import { Badge, Button } from "react-bootstrap"
import { PencilIcon } from "../assets/icons"
import { formatearFechaSpanish } from "../functions/formatearFecha"
import { elToast } from "../functions/Alerta"


export default function useHistorialVacacionesAdmin() {

    // variables
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const { URL: URL_MIO } = url()
    const [cargando, setCargando] = useState(false)
    const [buscar, setBuscar] = useState("")
    const [listaHistorial, setListaHistorial] = useState([])
    const [elementosFiltrados, setElementosFiltrados] = useState([])
    const [show, setShow] = useState(false);
    const vacacionesInicialJson = {
        id: 0,
        nombre_empleado: '',
        fecha_propuesta: '',
        fecha_solicitud: '',
        inicio_vacaciones: '',
        fin_vacaciones: '',
    }
    const vacacionesEditarJson = {
        id: 0,
        inicio_vacaciones: '',
        fin_vacaciones: '',
    }
    const [vacacionesEditar, setVacacionesEditar] = useState(vacacionesEditarJson)
    const [vacacionesSeleccionadas, setVacacionesSeleccionadas] = useState( vacacionesInicialJson )
    const [guardando, setGuardando] = useState(false)



    // funciones
    function traerHistorialVacaciones() {

        if (!objLogueado.email) {
            return
        }

        setCargando(true)

        var body = new FormData()
        body.append('funcion', 'historialComisionesVacaciones')
        body.append('email', objLogueado.email)

        fetch( URL_MIO, {
            method: 'post',
            body: body
        })
        .then(respuesta => respuesta.json())
        .then(datos => {
            setListaHistorial(datos)
			setElementosFiltrados(datos)
        })
        .catch(err => {
            alert('Hay problemas al traer tu historial de comisiones.')
        })
        .finally(() => setCargando(false))
    }

    const FechaVacaciones = ({ fecha }) => fecha
        ? formatearFechaSpanish(fecha, false)
        : <Badge pill bg="secondary">No asignado</Badge>


    const handleClose = () => {
        setShow(false)
        setVacacionesSeleccionadas( vacacionesInicialJson )
        setVacacionesEditar(vacacionesEditarJson)
    };
    const handleShow = () => setShow(true);


    const guardar = () => {

        if (!objLogueado.email) {
            return
        }

        setGuardando(true)

        // if (vacacionesEditar.id === 0) {

        //     elToast('Debes seleccionar un registro de vacaciones', 'info')
        //     return

        // } else if (vacacionesEditar.fin_vacaciones === '' && vacacionesEditar.inicio_vacaciones === '') {

        //     elToast('Debes seleccionar al menos una fecha', 'info')
        //     return

        // }

        let body = {
            email: objLogueado.email,
            ...vacacionesEditar,
            funcion: 'editarVacaciones'
        }

        fetch( URL_MIO, {
            method: 'post',
            body: JSON.stringify( body )
        })
        .then(respuesta => respuesta.json())
        .then(datos => {

            if (datos.codigo === 1) {
                // actualizamos desde el arreglo alv
                elToast('Vacaciones actualizadas', 'success')
                actualizarTabla( vacacionesEditar.id, vacacionesEditar.inicio_vacaciones, vacacionesEditar.fin_vacaciones )
            } else if (datos.codigo === 0) {
                elToast(datos.mensaje, 'info')
            } else {
                elToast('Error al actualizar', 'error')
            }

        })
        .catch(err => {
            alert('Hay problemas actualizar este registro.')
        })
        .finally(() => setGuardando(false))


    }

    function actualizarTabla(id, inicio_vacaciones, fin_vacaciones) {

        let a = listaHistorial.map(item => {
            if (item.id === id) {
                item.inicio_vacaciones = inicio_vacaciones
                item.fin_vacaciones = fin_vacaciones
            }
            return item
        })
        setListaHistorial(a)
    }


    // effect
    useEffect(() => {
        traerHistorialVacaciones()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
		let a = listaHistorial.filter(
			item => item.nombre && (item.nombre.toLowerCase().includes(buscar.toLowerCase())
				|| item.apellido.toLowerCase().includes(buscar.toLowerCase())
				|| item.fecha_propuesta.toLowerCase().includes(buscar.toLowerCase())
				|| item.fecha_solicitud.toLowerCase().includes(buscar.toLowerCase())
				|| item.inicio_vacaciones?.toLowerCase().includes(buscar.toLowerCase())
				|| item.fin_vacaciones?.toLowerCase().includes(buscar.toLowerCase())
            )
		);
		setElementosFiltrados(a)
		// eslint-disable-next-line
	}, [buscar])



    // tabla
    const style = {
        // paddingTop: '10px',
        // paddingBottom: '10px',
        fontSize: '15px'
    }

    const columns = [
        {
            name: 'Nombre del empleado',
            sortable: true,
            selector: row => row.id,
            maxWidth: '250px',
            style,
            cell: row => <> { row.nombre } { row.apellido } </>
        },
		{
			name: 'Mes seleccionado',
			sortable: true,
            style,
			selector: row => row.fecha_propuesta
		},
		{
			name: 'Fecha de solicitud',
			sortable: true,
			// maxWidth: '200px',
            style,
			selector: row => row.fecha_solicitud,
            cell: row => formatearFechaSpanish(row.fecha_solicitud)
		},
		{
			name: 'Inicio de vacaciones',
			sortable: true,
			// maxWidth: '50px',
            style,
			selector: row => row.inicio_vacaciones,
            cell: row => <FechaVacaciones fecha={ row.inicio_vacaciones }/>
		},
		{
			name: 'Fin de vacaciones',
			sortable: true,
			// maxWidth: '50px',
            style,
			selector: row => row.fin_vacaciones,
            cell: row => <FechaVacaciones fecha={ row.fin_vacaciones }/>
		},
		{
			name: 'Opciones',
			selector: row => row.id,
			maxWidth: '80px',
			cell: row => (
				<>
					<Button variant="outline-primary" size="sm" onClick={() => {
                        // setVacacionesSeleccionadas({
                        //     id: row.id,
                        //     nombre_empleado: row.nombre + ' ' + row.apellido,
                        //     fecha_propuesta: row.fecha_propuesta,
                        //     fecha_solicitud: row.fecha_solicitud,
                        //     inicio_vacaciones: row.inicio_vacaciones,
                        //     fin_vacaciones: row.fin_vacaciones
                        // })
                        setVacacionesEditar({
                            id: row.id,
                            inicio_vacaciones: row.inicio_vacaciones || '',
                            fin_vacaciones: row.fin_vacaciones || ''
                        })
                        handleShow()
                    }}>
						<PencilIcon/>
					</Button>
				</>
			)
		},
	];


    return {
        cargando, columns, elementosFiltrados, buscar, setBuscar,
        listaHistorial, handleClose, show, vacacionesSeleccionadas,
        FechaVacaciones, vacacionesEditar, setVacacionesEditar, guardar,
        guardando
    }
}

